export default "__VITE_ASSET__BkVG5ziX__"